<ng-container *ngIf="isVisible">
    <div [ngClass]="field.panelClass" [id]="field.id + '-container'">
        <mat-form-field class="full-width" [ngClass]="{ required: isRequired }">
            <mat-label *ngIf="field.label">{{ field.label | translate }}</mat-label>
            <input
                [id]="field.id"
                matInput
                [attr.formcontrolname]="field.name"
                [placeholder]="getPlaceholder()"
                (blur)="onAutocompleteBlur()"
                [formControl]="field?.autoClearOnFocus ? displayControl : control"
                [matAutocomplete]="auto"
            />
            <mat-icon
                *ngIf="field.clearable !== false && !control.disabled"
                class="clickable"
                matSuffix
                (click)="clearAutocomplete($event)"
                matTooltip="{{ 'COMMON.CLEAR_TOOLTIP' | translate }}"
                >clear</mat-icon
            >
            <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected($event)"
                (opened)="onAutocompleteOpened()"
                (closed)="onAutocompleteClosed()"
            >
                <mat-option *ngFor="let option of filteredOptions$ | async" [value]="getValue(option)">
                    {{ getDisplayText(option) }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <div class="mat-error" *ngIf="hasError">
            <div *ngFor="let error of errorMessages">{{ error | translateSmart }}</div>
        </div>
    </div>
</ng-container>
